import React from "react";
// ANT DESIGN COMPONENTS
import { Radio } from "antd";
// COMPONENTS
import FormInputText from "../../../../components/form/FormInputText";
// INTERFACES
import type { OpcUaIdentityForm } from "../../../../../interfaces/AdapterCdoOpcUa.interface";

/** Build a blank identity form value for a given kind, used when the radio selection changes. */
function blankIdentityForKind(kind: OpcUaIdentityForm["kind"]): OpcUaIdentityForm {
  if (kind === "username") return { kind: "username", username: "", password: "" };
  if (kind === "x509") return { kind: "x509", certificatePath: "", privateKeyPath: "" };
  return { kind: "anonymous" };
}

export default function IdentityEditor({
  identity,
  onChangeIdentity,
}: {
  identity: OpcUaIdentityForm;
  onChangeIdentity: (value: OpcUaIdentityForm) => void;
}) {
  const onChangeUsernameField = (value: string, field: "username" | "password") => {
    if (identity.kind !== "username") return;
    onChangeIdentity({ ...identity, [field]: value });
  };

  const onChangeX509Field = (value: string, field: "certificatePath" | "privateKeyPath") => {
    if (identity.kind !== "x509") return;
    onChangeIdentity({ ...identity, [field]: value });
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 mt-3">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span className="generalStyles__inputLabel">Identity</span>
          <div style={{ marginTop: 8 }}>
            <Radio.Group
              value={identity.kind}
              onChange={(e) => onChangeIdentity(blankIdentityForKind(e.target.value))}
            >
              <Radio value="anonymous">Anonymous</Radio>
              <Radio value="username">UserName</Radio>
              <Radio value="x509">X509</Radio>
            </Radio.Group>
          </div>
        </div>
      </div>
      {identity.kind === "username" && (
        <div className="row">
          <div className="col-12 col-md-6 mt-3">
            <FormInputText
              inputValue={identity.username}
              inputLabelName="Username"
              inputOnChange={(value) => onChangeUsernameField(value, "username")}
              inputVariableName="username"
              isRequired
              disabledInput={false}
            />
          </div>
          <div className="col-12 col-md-6 mt-3">
            <FormInputText
              inputValue={identity.password}
              inputLabelName="Password"
              inputOnChange={(value) => onChangeUsernameField(value, "password")}
              inputVariableName="password"
              isRequired
              disabledInput={false}
            />
          </div>
        </div>
      )}
      {identity.kind === "x509" && (
        <div className="row">
          <div className="col-12 col-md-6 mt-3">
            <FormInputText
              inputValue={identity.certificatePath}
              inputLabelName="Certificate Path"
              inputOnChange={(value) => onChangeX509Field(value, "certificatePath")}
              inputVariableName="certificatePath"
              isRequired
              disabledInput={false}
            />
          </div>
          <div className="col-12 col-md-6 mt-3">
            <FormInputText
              inputValue={identity.privateKeyPath}
              inputLabelName="Private Key Path"
              inputOnChange={(value) => onChangeX509Field(value, "privateKeyPath")}
              inputVariableName="privateKeyPath"
              isRequired
              disabledInput={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}
